export const addOrUpdateFont = (fontFamily, source, store, raw) => {
  const fonts = [];
  const { googleFonts, uploadedFonts } = store;

  source.attributes = {};

  for (const key in source.children) {
    if (Object.hasOwnProperty.call(source.children, key)) {
      if (source.children[key].attributes && key != "@font-face") {
        for (const key2 in source.children[key].attributes) {
          if (Object.hasOwnProperty.call(source.children[key].attributes, key2) && key2 == "font-family") {
            let font = source.children[key].attributes[key2];
            if (googleFonts.find((f) => f == font) && !fonts.some((f) => f.font == font)) fonts.push({ font, type: "GOOGLE" });
            if (uploadedFonts.find((f) => f.name == font) && !fonts.some((f) => f.font == font)) {
              const targetFont = uploadedFonts.find((f) => f.name == font);
              fonts.push({ font, ...targetFont });
            }
          }
        }
      } else {
        delete source.children[key];
      }
    }
  }

  let fontsString = "";

  fonts.map((f) => {
    if (f.type == "GOOGLE") {
      fontsString += createImport(f.font).replace("https: //", "https://");
    } else if (f?.adobe) {
      fontsString = f.importUrl + fontsString;
      fontsString += f.fontface;
    } else {
      fontsString += createFontFace(f);
    }
  });

  return fontsString;
};

const createFontFace = (cf) => {
  return `@font-face{ font-family: ${cf.font}; src: url('${cf.url}'); }`;
};

const createImport = (font) => {
  return `@import url("https://fonts.googleapis.com/css2?family=${font.replace(/\s/g, "+").replace("-", "+")}:wght@300;400;700;800&display=swap");
  `;
};
